import { CanAccess } from '@modules/common/components/CanAccess';
import { FileUploadInteractiveSVGIcon } from '@modules/integrationsV2/components/FileUploadInteractiveSVGIcon';
import { FileUploader } from '@modules/integrationsV2/components/FileUploader';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { HelpOutlineRounded } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import {
  IntegrationChannelType,
  PermissionOperation,
  PermissionResource,
} from 'generated/graphql';
import { getInstructionsUrlForChannel } from 'modules/ui/Settings/Integrations/utils/getInstructionsUrlForChannel';
import { useState } from 'react';

interface IntegrationSourceFileNotUploadedProps {
  selectedIntegrationSource: IntegrationSource;
}

export const IntegrationSourceFileNotUploaded = ({
  selectedIntegrationSource,
}: IntegrationSourceFileNotUploadedProps) => {
  const [isUploadButtonHovered, setIsUploadButtonHovered] = useState(false);

  const isDisabled = selectedIntegrationSource.isDisabled;

  return (
    <Stack pt={10} direction="row" alignItems="center" justifyContent="center">
      <Stack alignItems="center" justifyContent="center" spacing={3}>
        <Stack alignItems="center" justifyContent="center">
          <FileUploadInteractiveSVGIcon isHighlighted={isUploadButtonHovered} />
          <Stack direction="row" alignItems="center" spacing={1}>
            {isDisabled ? (
              <Stack textAlign="center">
                <Typography>
                  No files were uploaded to this integration before it was
                  disabled.
                </Typography>
                <Typography>
                  Consequently, no data has been ingested.
                </Typography>
              </Stack>
            ) : (
              <Typography>
                You haven't uploaded any file to this integration yet.
              </Typography>
            )}
            {!isDisabled && (
              <Button
                endIcon={<HelpOutlineRounded />}
                color="primary"
                onClick={() => {
                  window.open(
                    getInstructionsUrlForChannel({
                      type: IntegrationChannelType.FileUpload,
                    }),
                  );
                }}
                sx={{
                  whiteSpace: 'nowrap',
                  minWidth: 'max-content',
                }}
              >
                Read How
              </Button>
            )}
          </Stack>
        </Stack>
        {selectedIntegrationSource.integrationID && !isDisabled && (
          <CanAccess
            operation={PermissionOperation.Write}
            resource={PermissionResource.Integration}
          >
            <Box
              onMouseEnter={() => setIsUploadButtonHovered(true)}
              onMouseLeave={() => setIsUploadButtonHovered(false)}
            >
              <FileUploader
                id={selectedIntegrationSource.integrationID}
                buttonProps={{
                  size: 'large',
                }}
              />
            </Box>
          </CanAccess>
        )}
      </Stack>
    </Stack>
  );
};
